<template>
  <div class="d-flex">
    <div class="header">{{ header }}</div>
    <div v-if="! cell" class="cell"></div>
    <div v-else-if="phone" class="cell">
      <a :href="`tel:${phoneNumber}`">{{ cell }}</a>
    </div>
    <div v-else-if="email" class="cell">
      <a :href="`mailto:${cell}`">{{ cell }}</a>
    </div>
    <div v-else-if="map && cell.includes('<br>')" class="cell">
      <a :href="getMapUrl()" target="_blank"><AppMultilineText :value="cell"/></a>
    </div>
    <div v-else class="cell"><AppMultilineText :value="cell"/></div>
  </div>
</template>

<script>
import AppMultilineText from '@/components/AppMultilineText'

export default {
  name: 'AppTableRow',
  components: {AppMultilineText},
  props: {
    header: {
      type: String,
      required: true
    },
    cell: {
      type: String,
      required: true
    },
    phone: {
      type: Boolean,
      default: false
    },
    email: {
      type: Boolean,
      default: false
    },
    map: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    phoneNumber() {
      return this.cell.replace(/\D/g, '');
    }
  },
  methods: {
    getMapUrl() {
      const isAppleDevice = /Macintosh|iPad|iPhone/.test(navigator.userAgent)
      const param =  isAppleDevice ? 'address' : 'query'
      const query = new URLSearchParams({[param]: this.cell.replace('<br>', ', ')}).toString()
      const url = isAppleDevice ? 'maps.apple.com/?' : 'www.google.com/maps/search/?api=1&'
      return `https://${url}${query}`
    }
  }
}
</script>

<style scoped>
.header, .cell {
  font-family: Roboto, sans-serif;
  padding: 0 16px;
}

.header {
  width: 150px;
  min-width: 150px;
  font-size: .75rem;
  font-weight: 700;
}

.cell {
  font-size: .875rem;
}
</style>